"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orElse = exports.isT = exports.isNothing = void 0;
/**
 * Check is the value is a Nothing value
 * Nothing are considered undefined and null
 */
var isNothing = function (v) { return v === null || v === undefined; };
exports.isNothing = isNothing;
/**
 * Check whenever a potential maybe value is empty or not
 */
var isT = function (t) { return !exports.isNothing(t); };
exports.isT = isT;
function orElse() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.length === 1 ? function (v) { return (exports.isNothing(v) ? args[0] : v); } : exports.isNothing(args[1]) ? args[0] : args[1];
}
exports.orElse = orElse;
